<template>
    <v-container grid-list-md>
        <form v-on:submit.prevent="create">
            <v-layout row wrap>

                <v-flex xs12 sm12 md12>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.name"
                            :error-messages="errors.collect('data.name')"
                            label="Name"
                            data-vv-name="data.name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-btn large color="secondary" class="text--primary" type="submit">Create laboratory</v-btn>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-btn block outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    export default {
        data : function() {
            return {
                data : {
                    name: ''
                },
                error : false,
                message_error : null,
            }
        },
        created: function () {
            this.setSectionTitle();
        },
        methods: {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Create laboratory'
                });
            },
            create : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('createLaboratorio', this.data).then((res) => {
                            this.$router.push({ name : 'admin.amcs.list'});
                        }).catch((error) => {
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/CreateComponent.vue